// Export what is currently on screen. The download button hands over the whole
// published dataset, which is the right thing for replication but no help to
// someone who has just built a view and wants its numbers.

const escapeCell = (value) => {
	const text = value === null || value === undefined ? '' : String(value);
	return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const round = (value, places = 1) =>
	Number.isFinite(value) ? Number(value).toFixed(places) : '';

/**
 * A CSV of the ranked countries, with the filters and weighting that produced them
 * recorded in a comment header. A view without its provenance is not reproducible.
 */
export const buildViewCsv = ({ rows, year, weights, filters, weightingIsPublished, minSampleSize, withheld }) => {
	const describeFilter = ([key, values]) =>
		`#   ${key}: ${values.map((value) => value.label).join(', ')}`;

	const activeFilters = Object.entries(filters).filter(
		([, values]) => Array.isArray(values) && values.length > 0
	);

	const header = [
		`# World Risk Poll Resilience Index -- ${year}`,
		`# Exported ${new Date().toISOString().slice(0, 10)}`,
		`# Scores are population-weighted (PROJWT) means, 0-100.`,
		`# Dimension weighting: ${
			weightingIsPublished
				? 'equal, as published'
				: `custom -- individual ${weights.individual}, household ${weights.household}, community ${weights.community}, society ${weights.society}`
		}`,
		activeFilters.length ? '# Filters applied:' : '# Filters applied: none',
		...activeFilters.map(describeFilter),
		`# Countries withheld for fewer than ${minSampleSize} respondents: ${withheld}`,
		'#',
	];

	const columns = [
		'rank',
		'country',
		'region',
		'country_income_level',
		'resilience_index',
		'margin_of_error_95',
		'ci_low',
		'ci_high',
		'individual',
		'household',
		'community',
		'society',
		'respondents',
		'effective_sample_size',
		'countries_not_distinguishable',
	];

	const body = rows.map((row, index) =>
		[
			index + 1,
			row.country,
			row.region,
			row.incomeLabel,
			round(row.resilience),
			round(row.moe),
			round(row.ciLow),
			round(row.ciHigh),
			round(row.individual),
			round(row.household),
			round(row.community),
			round(row.society),
			row.count,
			Math.round(row.effectiveN),
			row.indistinguishable,
		]
			.map(escapeCell)
			.join(',')
	);

	return [...header, columns.join(','), ...body].join('\n');
};

export const downloadCsv = (filename, contents) => {
	const blob = new Blob([contents], { type: 'text/csv;charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const anchor = document.createElement('a');

	anchor.href = url;
	anchor.download = filename;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	URL.revokeObjectURL(url);
};
